import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;

const ErrorMessageTemplate = ({ errors }) => {
    return (
        <div>
            {errors.map((err) => (
                <div className='flex flex-col items-start'>
                    <Text strong>{err.section}</Text>
                    <ul>
                        {err.errors.map((e) => {
                            if (typeof e === 'object') {
                                if (Object.hasOwn(e, 'section') && Object.hasOwn(e, 'errors')) {
                                    return (
                                        <>
                                            <Text strong>{e.section}</Text>
                                            <ul>
                                                {e.errors.map((subErr) => (
                                                    <li>
                                                        <Text>{subErr}</Text>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    );
                                } else {
                                    return JSON.stringify(e);
                                }
                            }
                            return (
                                <li>
                                    <Text>{e}</Text>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );
};

export default ErrorMessageTemplate;
